/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
  $('.home-featured-inventory').find('.controls').addClass('dark');
  $('.home-featured-inventory').find('.controls').find('.link').addClass('link_brand-white');

  $('.home .body-types .body-types-carousel-content')
    .find('.body-content__button')
    .removeClass('btn-ui')
    .removeClass('btn-ui-4')
    .addClass('btn-brand-1');

  const testSlider = 'home-reviews-slider-cmh';
  const $currentSlide = $(`.controls-current-${testSlider}`);

  if ($currentSlide) {
    $currentSlide.text('1/' + $('.home-reviews .review').length);
  }

  $(`.${testSlider}`).on('init beforeChange', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.controls-dots-${testSlider}`).data('theme');
      if (theme) {
        dots.addClass('slick-dot ' + theme);
      }
    }
  });

  $(`.${testSlider}`).slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    adaptiveHeight: true,
    appendDots: $(`.controls-dots-${testSlider}`),
    nextArrow: $(`.controls-next-${testSlider}`),
    prevArrow: $(`.controls-prev-${testSlider}`),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '8%',
        },
      },
    ],
  });

  $(`.${testSlider}`).on('init reInit afterChange', function (event, slick, currentSlide) {
    const current = (currentSlide ? currentSlide : 0) + 1;
    if ($currentSlide) {
      $currentSlide.text(current + '/' + slick.slideCount);
    }
  });

  function setFinancedCashText() {
    $('.vehicle').each(function () {
      const $financedCheck = $(this).find('.vehicle-financed-cash-text');

      if ($financedCheck.length != 0) {
        $(this).find('.dealer-pricing').find('.title-text').text($financedCheck.data('cash-text'));
      }
    });
  }

  const $inventoryPage = $('.page-template-inventory, .home-featured-inventory');
  if ($inventoryPage.length != 0) {
    setFinancedCashText();
    $(document).on('post_render_inventory_search_results', function () {
      setFinancedCashText();
    });
  }

  const $vdpPage = $('.vdp-page');

  if ($vdpPage.length != 0) {
    const $financedPricing = $vdpPage.find('.financed-pricing');
    if ($financedPricing.length != 0) {
      const financedText = $vdpPage.find('.vehicle-financed-cash-text').data('cash-text');
      const $dealerPricing = $vdpPage.find('.dealer-pricing');
      $dealerPricing.find('.title-text').text(financedText);
    }
  }
});
